'use client';

import BookList from '@/components/reader/BookList';
import { BookOpen } from 'lucide-react';

export default function ReaderPage() {
  return (
    <div className="flex h-screen">
      {/* Book sidebar */}
      <div
        className="w-64 shrink-0 overflow-y-auto p-4"
        style={{
          backgroundColor: 'var(--bg-secondary)',
          borderRight: '1px solid rgba(200, 164, 94, 0.1)',
        }}
      >
        <BookList />
      </div>

      {/* Main content — welcome */}
      <div className="flex-1 flex items-center justify-center">
        <div className="text-center">
          <BookOpen
            size={64}
            className="mx-auto mb-4 opacity-20"
            style={{ color: 'var(--accent-gold)' }}
          />
          <h2
            className="text-xl font-semibold mb-2"
            style={{ color: 'var(--text-primary)' }}
          >
            Bible Reader
          </h2>
          <p
            className="text-sm max-w-sm"
            style={{ color: 'var(--text-secondary)' }}
          >
            Select a book from the sidebar to begin reading. Click on any verse
            to see details and cross-references.
          </p>
        </div>
      </div>
    </div>
  );
}
